import { render } from "./CreatePurchaseOrderView.vue?vue&type=template&id=a5d9138c&scoped=true"
import script from "./CreatePurchaseOrderView.vue?vue&type=script&lang=js"
export * from "./CreatePurchaseOrderView.vue?vue&type=script&lang=js"

import "./CreatePurchaseOrderView.vue?vue&type=style&index=0&id=a5d9138c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5d9138c"]])

export default __exports__